import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SET_ONBOARDING_EXPERIENCE } from "../../redux/actions/types";
import { Mixpanel } from "../../config/Mixpanel";
import Constants from "../../common/constants";

const cardsData = [
  {
    id: "job",
    icon: "https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/Onboarding/Group%2023240.png",
    label: "I’m A Student",
    customIcon: true,
  },
  {
    id: "promoted",
    icon: "https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/Onboarding/Vector%20(5).png",
    label: "I’m A Graudate",
    customIcon: false,
  },
  {
    id: "switch",
    icon: "https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/Onboarding/Group%2023241.png",
    label: "I Have 0-2 Yrs Of Exp.",
    customIcon: false,
  },
  {
    id: "learn",
    icon: "https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/Onboarding/Group%2023242.png",
    label: "I Have 3+ Yrs Of Exp.",
    customIcon: false,
  },
];

const StepTwo = ({setStep}) => {
  const dispatch = useDispatch();
  const firstName = useSelector((store) => store?.profileDetails?.first_name);
  const experience = useSelector((store) => store?.onBoarding?.experience);

  const handleSetExperience = (experience) => {
    Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_SECOND_STEP_CARD_CLICKED);
    dispatch({type: SET_ONBOARDING_EXPERIENCE, payload: experience});
    setTimeout(() => {
      setStep(3);
    }, 500);
  };

  useEffect(() => {
    Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_SECOND_STEP_LOADED);
  }, []);
  return (
    <div className="flex h-[60dvh]  flex-col items-center justify-center">
      <div className="text-[24px] leading-[125%] text-white text-left">
        Tell Us About Yourself, {firstName}, So We Can Personalise Your{" "}
        <span className="font-bold"> Experience </span>
      </div>

      <div className="w-full relative mt-8 inline-flex grid flex-[0_0_auto] grid-cols-2 grid-rows-2 items-center gap-2">
        {cardsData?.map((card) => (
          <div
            key={card.id}
            className={`relative flex h-full w-full cursor-pointer flex-col items-center justify-center overflow-hidden rounded-2xl border px-3 py-7 transition-all ${
              experience === card?.label
                ? "border-[#7fc241] bg-[#406aff33] shadow-[0px_0px_20px_#00000080]"
                : "border-transparent bg-[#406aff1a]"
            }`}
            onClick={() => handleSetExperience(card?.label)}
          >
               <div className="absolute top-4 right-4">
                <div
                  className={`h-4 w-4 cursor-pointer rounded-full border-2 transition-all ${
                    experience === card?.label
                      ? "border-[#7fc241] p-[2px]"
                      : "border-[#7fc241] bg-transparent"
                  }`}
                  onClick={() => handleSetExperience(card?.label)}
                >
                  {experience === card?.label && (
                    <div className="h-full w-full rounded-full bg-[#7fc241]"></div>
                  )}
                </div>
              </div>
            <div className="w-full p-0">
           
              <div className="relative flex inline-flex w-full flex-[0_0_auto] flex-col items-center gap-3">
                <img
                  className="relative w-auto h-[28px]"
                  alt="Group"
                  src={card.icon}
                  width={'auto'}
                  height={28}
                />

                <div className="relative w-fit whitespace-pre-line text-center text-base leading-[22.4px] tracking-[0] text-white [font-family:'Inter',Helvetica]">
                  <span className="text-[14px] font-medium ">{card.label}</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StepTwo;
